import { render, staticRenderFns } from "./TheAdministrativeLocationList.vue?vue&type=template&id=2b21c514&"
import script from "./TheAdministrativeLocationList.vue?vue&type=script&lang=js&"
export * from "./TheAdministrativeLocationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports